import React, { useContext, useEffect, useRef, useState } from 'react'
import moment from 'moment'
import { Button, Card, Col, Form, Image, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faUpload } from '@fortawesome/free-solid-svg-icons'
import { PieChart } from '../tools'
import { AuthContext } from '../components/ContextProvider'
import apiServices from '../services/apiServices'

function DashBoard() {
  const { auth } = useContext(AuthContext)
  console.log(auth)

  const [memberData, setmemberData] = useState({})
  const getMemgerData = async () => {
    const res = await apiServices.data({
      path: 'member',
      method: 'get',
    })
    setmemberData(res)
  }
  useEffect(() => {
    getMemgerData()
  }, [])
  console.log(memberData)

  const [images, setimages] = useState({
    imgs: [],
    generated: [],
  })
  const { imgs, generated } = images

  const getImages = async () => {
    const res = await apiServices.data({
      path: 'draft/images',
      method: 'get',
    })
    console.log(res)
    setimages(res)
  }
  console.log(images)

  useEffect(() => {
    getImages()
  }, [])

  const handleDelete = async (id) => {
    await apiServices.data({
      path: `draft/images/${id}`,
      method: 'delete',
    })
    getImages()
  }
  // svg size
  const ref = useRef(null)
  const [svgSize, setsvgSize] = useState(false)
  const getSize = () => {
    if (ref.current) {
      const style = getComputedStyle(ref.current)
      const height =
        ref.current.clientHeight -
        parseFloat(style.paddingTop) -
        parseFloat(style.paddingBottom)
      const width = ref.current.clientWidth
      return { width, height }
    }
    return false
  }
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const size = getSize()
      if (size.width !== svgSize.width || size.height !== svgSize.height)
        setsvgSize(size)
    })
    observer.observe(ref.current)
    return () => ref.current && observer.unobserve(ref.current)
  }, [])

  const [uploading, setuploading] = useState(null)
  useEffect(() => {
    const uploadImg = async () => {
      const getArrayBuffer = (files) =>
        new Promise((resolve) => {
          const reader = new FileReader()
          reader.addEventListener('load', () => {
            resolve(reader.result)
          })
          reader.readAsArrayBuffer(files)
        })
      const files = []
      files.push(getArrayBuffer(uploading))

      const buffered = await Promise.all(files)
      const arrayed = buffered.map((buffer) => ({
        name: uploading.name,
        data: Array.from(new Uint8Array(buffer)),
      }))
      const res = await apiServices.data({
        path: `draft/image`,
        method: 'post',
        data: {
          files: JSON.stringify(arrayed),
        },
      })
      if (!res.error) getImages()
      setuploading(null)
    }
    if (uploading) uploadImg()
  }, [uploading])

  const [filter, setfilter] = useState({
    type: '',
  })
  const { type } = filter

  return (
    <div
      className="content"
      style={{
        height: '800px',
        minHeight: '800px',
      }}
    >
      <Row className="h-50 p-3">
        <Col className="ps-0">
          <Card className="h-100 ps-0">
            <Card.Header className="d-flex py-3 ps-3">
              <h3 className="my-auto">你的帳號</h3>
            </Card.Header>
            <Card.Body>
              <Row className="p-2">
                <Col xs={3}>名稱</Col>
                <Col xs={5}>{auth.Name}</Col>
                {/* <Col className="ms-auto">
                  <Button variant="primary">編輯</Button>
                </Col> */}
              </Row>
              <Row className="p-2">
                <Col xs={3}>電子郵件位址</Col>
                <Col xs={5}>{auth.Email}</Col>
                {/* <Col className="ms-auto">
                  <Button variant="primary">編輯</Button>
                </Col> */}
              </Row>
              <Row className="p-2">
                <Col xs={3}>OPENAI API</Col>
                <Col xs={5}>ACTIVE</Col>
                {/* <Col className="ms-auto">
                  <Button variant="primary">編輯</Button>
                </Col> */}
              </Row>
              <Row className="p-2">
                <Col xs={3}>IMAGE API</Col>
                <Col xs={5}>ACTIVE</Col>
                {/* <Col className="ms-auto">
                  <Button variant="primary">編輯</Button>
                </Col> */}
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col className="pe-0">
          <Card className="h-100 pe-0">
            <Card.Header className="d-flex py-3 ps-3">
              <h3 className="my-auto">用量</h3>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col xs={4} ref={ref} className="ps-3">
                  <PieChart
                    setting={{
                      ...svgSize,
                      breakdowns: ['count'],
                      labels: ['count'],
                      datas: [
                        [
                          { count: imgs.length },
                          { count: generated.length },
                          // { count: 1000 },
                          // { count: 1000 },
                          // { count: 1000 },
                        ],
                      ],
                      showControl: false,
                      selectedField: 'count',
                      padding: 0,
                      donutThickness: 25,
                      color: [
                        '#FCBF49',
                        '#D62828',
                        '#247BA0',
                        '#59C3C3',
                        '#e88631',
                        '#B5AF8D',
                      ],
                    }}
                  />
                </Col>
                <Col>
                  <Row className="p-2">
                    <Col>總圖片數</Col>
                    <Col>{imgs.length + generated.length}</Col>
                  </Row>
                  <Row className="p-2">
                    <Col>上傳圖片數</Col>
                    <Col>{imgs.length}</Col>
                  </Row>
                  <Row className="p-2">
                    <Col>生成圖片數</Col>
                    <Col>{generated.length}</Col>
                  </Row>
                  {/* <Row>
                    <Col>All</Col>
                    <Col>1000</Col>
                  </Row> */}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="p-3 h-75">
        <Card className="px-0 w-100 h-100">
          <Card.Header className="py-3">
            <Row>
              <Col className="d-flex" xs={2}>
                <h3 className="my-auto ps-3 text-nowrap">素材庫</h3>
              </Col>
              <Col xs={2}>
                <Form.Select
                  value={type}
                  onChange={(e) =>
                    setfilter({
                      ...filter,
                      type: e.target.value,
                    })
                  }
                >
                  <option value="">全部素材</option>
                  <option value="img">上傳圖片</option>
                  <option value="generated">生成圖片</option>
                </Form.Select>
              </Col>
              <Col className="d-flex">
                <Button
                  variant="btn-dai text-dai ms-auto my-auto"
                  title="上傳"
                  onClick={(e) => {
                    e.stopPropagation()
                  }}
                >
                  <Form.Label className="m-auto text-dai" htmlFor="uploader">
                    上傳素材&ensp;
                    <FontAwesomeIcon icon={faUpload} />
                  </Form.Label>
                </Button>
                <Form.Control
                  id="uploader"
                  name="file"
                  type="file"
                  onChange={(e) => {
                    setuploading(e.target.files[0])
                    e.target.value = ''
                    e.stopPropagation()
                  }}
                  onClick={(e) => {
                    e.stopPropagation()
                  }}
                  className="p-0 m-0 border-0"
                  style={{
                    visibility: 'hidden',
                    width: '0px',
                    height: '0px',
                  }}
                />
              </Col>
            </Row>
          </Card.Header>
          <Card.Body className="w-100">
            {(!type || type === 'img') && (
              <>
                <Row className="mb-3">
                  <h4>上傳圖片</h4>
                </Row>
                <Row className="w-100 flex-wrap ps-4">
                  {imgs.map(({ setting, created_on, media_id }) => (
                    <Col className="py-3 border rounded" xs={3}>
                      <Row className="px-4 pb-4" style={{ height: '300px' }}>
                        <Image
                          className="m-auto"
                          style={{
                            height: 'auto',
                            // maxHeight,
                            // minHeight: '200px',
                            maxWidth: '100%',
                          }}
                          src={`api/draft/image/${
                            typeof setting.src === 'string'
                              ? setting.src
                              : setting.src?.name
                          }`}
                          alt="圖片失效"
                        />
                      </Row>
                      <Row className="text-nowrap" style={{ height: '10%' }}>
                        <Col>
                          建立日期：{moment(created_on).format('yyyy-MM-DD')}
                        </Col>
                        <Col className="d-flex">
                          <div
                            className="ms-auto"
                            onClick={() => handleDelete(media_id)}
                            aria-hidden
                          >
                            刪除&ensp;
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  ))}
                </Row>
              </>
            )}
            {(!type || type === 'generated') && (
              <>
                <Row className="mb-3">
                  <h4>生成圖片</h4>
                </Row>
                <Row className="w-100 flex-wrap ps-4">
                  {generated.map(({ image_job_id, created_on }) => (
                    <Col className="py-3 border rounded" xs={3}>
                      <Row className="px-4 pb-4" style={{ height: '300px' }}>
                        <Image
                          className="m-auto"
                          style={{
                            height: 'auto',
                            // maxHeight,
                            // minHeight: '200px',
                            maxWidth: '100%',
                          }}
                          src={`api/draft/image/imagejob:${image_job_id}_0`}
                          alt="圖片失效"
                        />
                      </Row>
                      <Row className="text-nowrap" style={{ height: '10%' }}>
                        <Col>
                          建立日期：{moment(created_on).format('yyyy-MM-DD')}
                        </Col>
                        {/* <Col className="d-flex">
                          <div
                            className="ms-auto"
                            onClick={() => handleDelete(media_id)}
                            aria-hidden
                          >
                            刪除&ensp;
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </div>
                        </Col> */}
                      </Row>
                    </Col>
                  ))}
                </Row>
              </>
            )}
          </Card.Body>
        </Card>
      </Row>
    </div>
  )
}

export default DashBoard
